<template>
	<div class="kun_loading77_container">
		<div class="loader"></div>
	</div>
</template>


<script>
	export default {
		name: "kun_loading77",
	}
</script>


<style scoped>
	.kun_loading77_container {
		display: flex;
		justify-content: center;
		align-items: center;

	}

	.loader {
		width: 0;
		height: 4.8px;
		display: inline-block;
		position: relative;
		background: #54f98d;
		box-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
		box-sizing: border-box;
		animation: animFw 8s linear infinite;
	}

	.loader::after,
	.loader::before {
		content: "";
		width: 10px;
		height: 1px;
		background: #fff;
		position: absolute;
		top: 9px;
		right: -2px;
		opacity: 0;
		transform: rotate(-45deg) translateX(0px);
		box-sizing: border-box;
		animation: coli1 0.3s linear infinite;
	}

	.loader::before {
		top: -4px;
		transform: rotate(45deg);
		animation: coli2 0.3s linear infinite;
	}

	@keyframes animFw {
		0% {
			width: 0;
		}

		100% {
			width: 100%;
		}
	}

	@keyframes coli1 {
		0% {
			transform: rotate(-45deg) translateX(0px);
			opacity: 0.7;
		}

		100% {
			transform: rotate(-45deg) translateX(-45px);
			opacity: 0;
		}
	}

	@keyframes coli2 {
		0% {
			transform: rotate(45deg) translateX(0px);
			opacity: 1;
		}

		100% {
			transform: rotate(45deg) translateX(-45px);
			opacity: 0.7;
		}
	}
</style>
